class Monitoring.Models.SocialContents.WebchatContentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.AnalysisUnitFactory().create(socialContent, allTags)
    content.set({ possibleTags: allTags })
    return content

  canHandle: (socialContent) ->
    return (socialContent.data && socialContent.data.type == 'webchat')